import React, { useEffect, useState } from 'react'

import { ADMIN_USER_TYPE } from '../../../services/UserService';
import QuestionTypeSingleChoice from './QuestionTypes/QuestionTypeSingleChoice';
import QuestionTypeMultiChoice from './QuestionTypes/QuestionTypeMultiChoice';
import QuestionTypeParagraph from './QuestionTypes/QuestionTypeParagraph';
import QuestionTypeMatchTheColumn from './QuestionTypes/QuestionTypeMatchTheColumn';
import QuestionTypeSubjective from './QuestionTypes/QuestionTypeSubjective';

const QuestionCreateTypeFactory = ({ selectedType, isImageBased, selectedTopics, selectedTags, onRequestClose, onAddQuestion, isQuestionDataValid, setIsSaving, user = ADMIN_USER_TYPE }) => {

    useEffect(() => {
    }, [selectedType, isImageBased])

    const renderQuestionCreate = () => {
        switch (selectedType.id) {
            case 'multi choice':
                return <QuestionTypeMultiChoice isImageBased={isImageBased} topics={selectedTopics} tags={selectedTags} hasSubmit={true} onRequestClose={onRequestClose} onAddQuestion={onAddQuestion} isQuestionDataValid={isQuestionDataValid} setIsSaving={setIsSaving} />;
            case 'paragraph':
                return <QuestionTypeParagraph isImageBased={isImageBased} topics={selectedTopics} tags={selectedTags} onRequestClose={onRequestClose} onAddQuestion={onAddQuestion} isQuestionDataValid={isQuestionDataValid} setIsSaving={setIsSaving} />;
            case 'match the column':
                return <QuestionTypeMatchTheColumn topics={selectedTopics} tags={selectedTags} onRequestClose={onRequestClose} onAddQuestion={onAddQuestion} isQuestionDataValid={isQuestionDataValid} />;
            case 'numerical':
                return <QuestionTypeSubjective type='numerical' tags={selectedTags} isImageBased={isImageBased} topics={selectedTopics} hasSubmit={true} onRequestClose={onRequestClose} onAddQuestion={onAddQuestion} isQuestionDataValid={isQuestionDataValid} setIsSaving={setIsSaving} />;
            case 'subjective':
                return <QuestionTypeSubjective isImageBased={isImageBased} topics={selectedTopics} tags={selectedTags} hasSubmit={true} onRequestClose={onRequestClose} onAddQuestion={onAddQuestion} isQuestionDataValid={isQuestionDataValid} setIsSaving={setIsSaving} />;
            default:
                return <QuestionTypeSingleChoice isImageBased={isImageBased} topics={selectedTopics} tags={selectedTags} hasSubmit={true} onRequestClose={onRequestClose} onAddQuestion={onAddQuestion} isQuestionDataValid={isQuestionDataValid} setIsSaving={setIsSaving} />;
        }
    }

    return (
        <>
            {selectedType && selectedType.id && renderQuestionCreate()}
        </>

    );
}
export default QuestionCreateTypeFactory;